import InfoPersonal from "./InfoPersonal"
export default InfoPersonal